import React, { lazy, Suspense } from "react";
import LoadingPanel from "@/components/loadingPanel";

const ChartsCore = lazy(() => import("./chartsCore"));

const Charts = (props) => {
  return (
    <Suspense
      fallback={
        <div className="border-edge flex h-full min-h-[260px] flex-col rounded-lg border">
          <LoadingPanel />
        </div>
      }
    >
      <ChartsCore {...props} />
    </Suspense>
  );
};

export default Charts;
